module.exports = __webpack_public_path__ + "img/appstore.fee2deaa.svg";